module.exports = __webpack_public_path__ + "static/media/metrics_speechBubble.33441d3a.svg";